"use client";
import { Heading, Box, Text, SimpleGrid, Icon, VStack } from "@chakra-ui/react";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import { SectionDivider } from "app/components/shared/SectionDivider";
import { CAPABILITIES_LIST } from "./constants";

const Capabilities = () => {
  return (
    <VStack paddingX={8} data-cy="section-capabilities">
      <SectionDivider label="Platform Capabilities" padding={"2rem 0"} />
      <Box>
        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 3, lg: 5 }}
          spacing={{ base: 6, sm: 8 }}
        >
          {CAPABILITIES_LIST.map((capability, index) => {
            return (
              <VStack key={index}>
                <Box mb={2}>
                  <Icon
                    as={capability.icon}
                    color="brand.100"
                    fontSize={"80px"}
                    display="flex"
                    alignItems={"center"}
                  />
                </Box>
                <Heading textAlign={"center"} variant={HEADING_VARIANTS.SUBTITLE3}>
                  {capability.title}
                </Heading>
                <Text textAlign={"center"}>{capability.subtitle}</Text>
              </VStack>
            );
          })}
        </SimpleGrid>
      </Box>
    </VStack>
  );
};

export default Capabilities;
